import { Box } from '@cp/ds/src/components/box';
import { BREAKPOINTS_CONFIG, styled } from '@cp/ds';
import { Stack } from '@cp/ds/src/components/stack';
import { withProps } from '@cp/ds/src/hocs';
import { Pagination } from '@cp/ds/src/components/pagination';
import { useGetQueryParams } from '@cp/shared/queryParams';
import { Skeleton } from '@cp/ds/src/components/skeleton';
import { DEFAULT_FILTERS_VALUES, PER_PAGE } from '../../lib/config';
import { ProcessingAndReviewsFiltersType, useProcessingAndReviews } from '../processingAndReviews';
import { useIsLoading } from '../../model/useIsLoading';

const Wrap = withProps(
  styled(Stack)(({ theme }) => ({
    position: 'fixed',
    bottom: 0,
    right: 0,
    height: 64,
    width: 'calc(100vw - 270px)',
    background: theme.palette.white,
    boxShadow: '0px 0px 16px 0px #00000021',

    [theme.breakpoints.down(BREAKPOINTS_CONFIG.lg)]: {
      width: '100%',
    },
  })),
  {
    alignItems: 'center',
    justifyContent: 'center',
  },
);

export const ProcessingAndReviewsPagination = () => {
  const isLoading = useIsLoading();
  const { form, data } = useProcessingAndReviews();
  const queryParams = useGetQueryParams<ProcessingAndReviewsFiltersType>();
  const currentPage = queryParams.page || DEFAULT_FILTERS_VALUES.page || 1;

  const handleChangePage = (_, page: number) => {
    if (data.isLoading) {
      return null;
    }
    form.setValue('page', page);
  };

  const lastPage = Math.ceil(data.totalCount / PER_PAGE);

  return (
    <Box sx={{ height: 64 }}>
      <Wrap>
        {!isLoading ? (
          lastPage > 1 && <Pagination currentPage={currentPage} lastPage={lastPage} onChange={handleChangePage} />
        ) : (
          <Skeleton sx={{ width: '96%', height: 50 }} />
        )}
      </Wrap>
    </Box>
  );
};
